/**
 * Прив’язка полів управлінського контуру до понять довідника (значок «?» біля підпису поля).
 * Ключ — `mgmt.<сутність>.<поле>`, значення — термін словника (GET /api/v1/kb/glossary).
 * Мапу підключено в features/knowledge/fieldTerms.ts (FIELD_TERMS). Поле в інтерфейсі: <Field term="mgmt.<сутність>.<поле>">.
 * «Критерії приймання» й «Ініціатор» у словнику поки немає — значок з’явиться, щойно поняття додадуть.
 */
export const MGMT_FIELD_TERMS: Readonly<Record<string, string>> = {
  // Управлінська одиниця
  'mgmt.unit.kind': 'УО',
  'mgmt.unit.result': 'ЦКП',
  'mgmt.unit.acceptanceCriteria': 'Критерії приймання',
  'mgmt.unit.initiator': 'Ініціатор',
  // Координації
  'mgmt.coordination': 'Координація',
  'mgmt.coordination.protocol': 'Протокол координації',
  'mgmt.coordination.horizontal': 'Горизонтальна координація',
};
